<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0" [formGroup]="centerCodesForm">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <!-- <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">{{title}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{title}} - Details</li>
                            </ol>
                        </div>
                    </div> -->
                    <!-- list of course start  -->
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row mb-1">
                                        <div class="col-sm-9">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/DistrictMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            {{title_one}}
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        {{sub_title_one}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <mat-form-field appearance="outline" class="example-full-width mr-2">
                                                <mat-label>Search Districts Records</mat-label>
                                                <input class="color" matInput placeholder="Search Districts Records"
                                                    (keyup)="keypress()">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="fixTableHead">
                                        <table id="datatable" class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th width="13%" class="f600">
                                                        Code
                                                    </th>
                                                    <th width="77%" class="f600">
                                                        Name
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        Dist
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="DistrictList.length > 0">
                                                <tr *ngFor="let District of DistrictList; let i = index"
                                                    (click)="onCourseListSelection(i)">
                                                    <td>{{District.DsCode}} </td>
                                                    <td>{{District.DsName}} </td>
                                                    <td>{{District.Dist}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- <div class="row clearfix">
                                        <div class="col-sm-6">

                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text  btn-raised "
                                                *ngIf="submitButton" (click)="ValidateAndProcess()">Sequlise Districts</button>

                                            <button type="button"
                                            class="btn btn-primary my-2 me-2 mt-0 btn-icon-text  btn-raised "
                                            *ngIf="submitButton" (click)="generateCode()">Generate Codes</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text  btn-raised "
                                                *ngIf="submitButton" (click)="loadCodeListGrid()">List Centers</button>
                                        </div>

                                        <div class="col-sm-6">
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised "
                                                *ngIf="submitButton">Exit</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised "
                                                *ngIf="submitButton">Print Center</button>
                                        </div>
                                    </div>
                                     -->
                                     <hr>
                                    <div class="row mb-2 mt-3">
                                        <div class="col-sm-12 pri-0 prpl ">
                                            <button type="button" *ngIf="submitButton"
                                                class="btn btn-primary btn-icon-text floatright mt-1 fl"
                                                (click)="ValidateAndProcess()">
                                                <span style="display: contents; align-items: center;">

                                                    Sequlise Districts
                                                </span>
                                            </button>

                                            <button type="button" *ngIf="submitButton"
                                                class="btn fl wd btn-primary btn-icon-text floatright mt-1"
                                                (click)="loadCodeListGrid()">
                                                <span style="display: contents; align-items: center;">
                                                    List Of Centers
                                                </span>
                                            </button>

                                            <button type="button" *ngIf="submitButton && centerCodeCreate"
                                                class="btn fl1 wd btn-primary btn-icon-text floatright mt-1"
                                                (click)="generateCode()">
                                                <span style="display: contents; align-items: center;">

                                                    Generate Codes
                                                </span>
                                            </button>

                                            <button type="button" *ngIf="submitButton"
                                                class="btn btn-primary btn-icon-text floatright mt-1 fr">
                                                <span style="display: contents; align-items: center;">
                                                    <img alt="Logo" src="../../assets/img/exit.gif"
                                                        class="mh-45px pb-2">
                                                    Exit
                                                </span>
                                            </button>
                                            <!-- <button type="button" *ngIf="submitButton" (click)="print()" 
                                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="15vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                    Print
                                                </span>
                                            </button> -->
                                            <!-- <button type="button" 
                                                class="btn wd btn-primary btn-icon-text floatright mt-1 fr">
                                                <span style="display: contents; align-items: center;">

                                                    Print
                                                </span>
                                            </button> -->
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-9 ">
                                            <p class="mb-1">
                                                <span class="main-content-label"><b>{{title_two}}</b></span>
                                            </p>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{sub_title_two}}
                                            </p>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search Center Records</mat-label>
                                                <input class="color" matInput placeholder="Search Center Records"
                                                    (keyup)="keypress()">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="table-responsive table-container">
                                        <table id="datatable" class="table  table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th width="13%" class="f600">
                                                        Code
                                                    </th>
                                                    <th width="67%" class="f600">
                                                        Name
                                                    </th>
                                                    <th width="5%" class="f600">
                                                        Dist
                                                    </th>
                                                    <th width="5%" class="f600">
                                                        Colg
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="CodesList.length > 0">
                                                <tr *ngFor="let course of CodesList;">
                                                    <td> {{course.GcCode}} </td>
                                                    <td>{{course.CgName}} </td>
                                                    <td> {{course.DsCode}} </td>
                                                    <td> {{course.CgCode}} </td>
                                                    <td class="text-center">
                                                        <a class="floating" title="Edit"
                                                            (click)="editGeneratedCode(course)">
                                                            <i class="fa fa-edit"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>